<!-- SocialSharing.svelte -->
<script>
    let showShareModal = false;
    const shareUrl = typeof window !== 'undefined' ? window.location.href : '';
    const shareText = 'Check out this interactive audio essay about AI consciousness.';
  
    const openLinkedInDM = () => {
      // Replace with your actual LinkedIn profile URL
      window.open('mailto:aps@actually-useful.xyz', '_blank');
    };
  
    const shareContent = () => {
      if (navigator.share) {
        navigator.share({
          title: "Sentient AI is Closer Than You Think. We're Not Ready.",
          text: shareText,
          url: shareUrl
        }).catch(error => {
          console.error('Error sharing:', error);
          showShareModal = true;
        });
      } else {
        showShareModal = true;
      }
    };
  
    const closeModal = () => {
      showShareModal = false;
    };
  
    const handleModalClick = (e) => {
      if (e.target.classList.contains('modal-backdrop')) {
        closeModal();
      }
    };
  </script>
  
  <div class="social-buttons">
    <button
      on:click={openLinkedInDM}
      class="button linkedin"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
      </svg>
      Tell me your thoughts
    </button>
    <button
      on:click={shareContent}
      class="button share"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
        <polyline points="16 6 12 2 8 6"/>
        <line x1="12" y1="2" x2="12" y2="15"/>
      </svg>
      Tell everyone
    </button>
  </div>
  
  {#if showShareModal}
  <div 
    class="modal-backdrop"
    on:click={handleModalClick}
  >
    <div class="modal-content" role="dialog" aria-modal="true">
      <h3>Share this essay</h3>
      <div class="share-buttons">
        <a
          href="https://twitter.com/intent/tweet?url={encodeURIComponent(shareUrl)}&text={encodeURIComponent(shareText)}"
          target="_blank"
          rel="noopener noreferrer"
          class="share-button twitter"
        >
          Share on Twitter
        </a>
        <a
          href="https://www.facebook.com/sharer/sharer.php?u={encodeURIComponent(shareUrl)}"
          target="_blank"
          rel="noopener noreferrer"
          class="share-button facebook"
        >
          Share on Facebook
        </a>
        <a
          href="https://www.linkedin.com/sharing/share-offsite/?url={encodeURIComponent(shareUrl)}"
          target="_blank"
          rel="noopener noreferrer"
          class="share-button linkedin"
        >
          Share on LinkedIn
        </a>
      </div>
      <button class="close-button" on:click={closeModal}>
        Close
      </button>
    </div>
  </div>
{/if}
  
  <style>
    .social-buttons {
      display: flex;
      justify-content: center;
      gap: 1rem;
      margin: 2rem 0;
    }
  
    .button {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem 1rem;
      border-radius: 0.375rem;
      font-weight: 500;
      transition: background-color 0.2s;
      color: white;
      border: none;
      cursor: pointer;
    }
  
    .button svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  
    .share-button.linkedin {
        background-color: #0077b5;
    }

    .share-button.linkedin:hover {
        background-color: #005885;
    }

    .button.linkedin {
        background-color: #0077b5;
    }

    .button.linkedin:hover {
        background-color: #005885;
    }
  
    .share {
      background-color: #1a1a1a;
    }
  
    .share:hover {
      background-color: #333;
    }
  
    .modal-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    }
  
    .modal-content {
      background-color: white;
      padding: 1.5rem;
      border-radius: 0.5rem;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      max-width: 90%;
      width: 320px;
      animation: modal-pop 0.2s ease-out;
    }
  
    @keyframes modal-pop {
      from {
        opacity: 0;
        transform: scale(0.95);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
  
    h3 {
      font-size: 1.25rem;
      font-weight: 600;
      margin-bottom: 1rem;
      text-align: center;
    }
  
    .share-buttons {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
    }
  
    .share-button {
      display: block;
      padding: 0.75rem 1rem;
      text-align: center;
      color: white;
      text-decoration: none;
      border-radius: 0.375rem;
      font-weight: 500;
      transition: background-color 0.2s;
    }
  
    .twitter {
      background-color: #1da1f2;
    }
  
    .twitter:hover {
      background-color: #1a8cd8;
    }
  
    .facebook {
      background-color: #1877f2;
    }
  
    .facebook:hover {
      background-color: #1664d9;
    }
  
    .close-button {
      width: 100%;
      padding: 0.5rem;
      margin-top: 1rem;
      border: none;
      background: none;
      color: #666;
      cursor: pointer;
      font-size: 0.875rem;
    }
  
    .close-button:hover {
      color: #333;
    }
  </style>